import React from "react";
import {
  MessageCircle,
  Layers,
  Lightbulb,
  LineChart,
  Zap,
  Handshake,
} from "lucide-react";
import Reveal from "../motion/Reveal";
import { reasons } from "../../data/content";

const iconMap = { MessageCircle, Layers, Lightbulb, LineChart, Zap, Handshake };

export default function Why() {
  return (
    <section
      className="relative bg-brand-light py-32 lg:py-44 border-y border-brand-border"
      data-testid="why-section"
    >
      <div className="max-w-[90rem] mx-auto px-6 sm:px-8 lg:px-12">
        <div className="max-w-2xl">
          <Reveal>
            <p className="eyebrow">Warum Metalotsen</p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 font-display font-medium text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-balance">
              Weil Handwerk immer noch der Unterschied ist.
            </h2>
          </Reveal>
        </div>

        <div className="mt-16 lg:mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {reasons.map((r, i) => {
            const Icon = iconMap[r.icon];
            return (
              <Reveal key={r.title} delay={i * 0.06}>
                <div
                  className="group h-full p-8 lg:p-10 rounded-3xl bg-white border border-brand-border transition-all duration-500 hover:border-brand-accent/40 hover:shadow-[0_25px_60px_-25px_rgba(15,23,42,0.18)] hover:-translate-y-1"
                  data-testid={`reason-card-${i}`}
                >
                  <div className="relative h-14 w-14 rounded-2xl bg-brand-primary text-white grid place-items-center transition-all duration-500 group-hover:-rotate-6 group-hover:scale-105 group-hover:shadow-[0_0_0_6px_rgba(14,165,233,0.12)]">
                    <Icon className="h-5 w-5 text-brand-accent transition-transform duration-500 group-hover:scale-110" />
                  </div>
                  <h3 className="mt-6 text-xl lg:text-2xl font-semibold tracking-tight">
                    {r.title}
                  </h3>
                  <p className="mt-3 text-brand-muted leading-relaxed">{r.body}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
